import React from "react";
import {ReactComponent as ImageNotFound} from '../images/not_found.svg';

export default function EntityNotFound(props) {
   const message = props.children;
    return (
      <>
      <div style={{width: '300px', margin: '0 auto'}}><ImageNotFound/>
      {message ? (
          <h3 style={{color: '#778899', 'textAlign': 'center'}}>{message}</h3>
        ) : (
          <h3 style={{color: '#778899', 'textAlign': 'center'}}>Страница не найдена</h3>
        )}
    </div>

      </>
    );
}
